import React from "react";
import { SlideShell } from "../../../shared/components/SlideShell";

const IMG = "https://images.pexels.com/photos/15630997/pexels-photo-15630997.jpeg";

export const Slide5 = ({ t, total, onActive }) => {
  return (
    <SlideShell index={4} total={total} onActive={onActive} label="Why It Works">
      <div className="absolute inset-0 radial-gold opacity-50" />

      <div className="relative z-10 grid grid-cols-1 lg:grid-cols-12 gap-12 w-full max-w-7xl px-6 md:px-12 items-center">
        <div className="lg:col-span-5 order-2 lg:order-1">
          <div className="relative">
            <div className="absolute -inset-4 bg-[var(--ph-accent-glow)] blur-3xl" />
            <div className="relative glass-strong rounded-2xl overflow-hidden aspect-[3/4] gold-glow">
              <img
                src={IMG}
                alt="Cultural affinity"
                className="w-full h-full object-cover"
                style={{ filter: "saturate(0.9)" }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent" />
              <div className="absolute top-5 left-5 right-5 flex justify-between items-start">
                <span className="pill text-[10px]">CULTURE · TRUST</span>
                <span className="font-mono text-[10px] text-[var(--ph-accent)]">
                  RETENTION
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7 order-1 lg:order-2">
          <div className="overline mb-6">{t.overline}</div>
          <h2 className="font-display font-medium text-5xl md:text-6xl lg:text-7xl leading-[1.02] tracking-tighter">
            {t.heading}
          </h2>
          <p className="mt-8 text-lg md:text-xl text-neutral-300 font-light leading-relaxed max-w-xl">
            {t.body}
          </p>

          <div className="mt-10 glass-strong rounded-2xl p-8 border-l-2 border-[var(--ph-accent)]">
            <div className="font-mono text-[10px] tracking-widest text-[var(--ph-accent)] mb-3">
              THE REAL POSITION
            </div>
            <p className="font-display text-2xl md:text-3xl leading-tight italic text-white">
              "{t.pull}"
            </p>
          </div>
        </div>
      </div>
    </SlideShell>
  );
};


